export const EVALUATION_STATUS_MODEL = "evaluation-status";

const evaluationStatusModel = {
  name: "",
  previousStatus: "",
  displayOrder: ""
};

export default evaluationStatusModel;
